import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { PartsCompleteButton } from '@app/react/uikit/arrow_parts/PartsCompleteButton';
import type { PartsProduct } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { useHandleClick } from './operator';

interface HonsuCompleteButtonContainerProps {
    even?: boolean;
}
export const HonsuCompleteButtonContainer: FC<HonsuCompleteButtonContainerProps> = (
    props,
) => {
    const { even } = props;

    const unit = useSelector<AppState, PartsProduct | null>((state) => state.customize.unit);
    const onClick = useHandleClick('honsu');

    const status = unit === null ? 'none' : 'valid';

    return (
        <PartsCompleteButton
            title="矢の本数"
            status={status}
            required
            onClick={onClick}
            even={even}
        />
    );
};
